import { Text, Box } from '../../Base';
import { LayoutProps, SpaceProps, ColorProps, FlexboxProps } from 'styled-system';

export interface ModalContentProps
  extends React.HTMLAttributes<HTMLDivElement>,
    LayoutProps,
    SpaceProps,
    ColorProps,
    FlexboxProps {
  color?: string;
  children: React.ReactNode;
}

const ModalContent = ({ children, ...props }: ModalContentProps) => {
  return (
    <Box {...props}>
      {typeof children === 'string' ? (
        <Text textStyle={'body1'} color={'grayscale.700'} style={{ whiteSpace: 'pre-line' }}>
          {children}
        </Text>
      ) : (
        children
      )}
    </Box>
  );
};

export default ModalContent;
